// extracted by mini-css-extract-plugin
export var legendIndicator = "_ec-1";
export var legendRight = "_ec-0";